<template>
    <section>
        <div v-if="showButton && !isReferrer" :class="['welcome__button', unreadCount > 0 ? 'has-unread' : '']"
             @click="toggleModal(true)">
            <span :class="['welcome__button__text', unreadCount > 0 ? '' : '']">What’s New?</span>
            <el-badge v-if="unreadCount > 0" :value="unreadCount" class="welcome__button__badge"></el-badge>
        </div>

        <section class="welcome" v-if="openModal">
            <div class="welcome__background"></div>

            <section class="welcome__modal">
                <!-- Modal Header -->
                <div class="welcome__modal__header w-100 d-flex align-items-center justify-content-between">
                    <div>
                        <el-button v-if="!relativeMenuPosition" @click="openPostsMenu = true" type="info" plain>
                            {{ postsMenuTitle }}
                        </el-button>
                        <el-button
                            @click="fetchNotifications"
                            type="info"
                            plain
                            :icon="isLoading ? 'el-icon-loading' : 'el-icon-refresh'"
                        ></el-button>
                    </div>
                    <span></span>
                    <img class="welcome__modal__header__logo" src="@assets/img/logos/ambcloud-logo-notag.svg"
                         alt="Ambition Cloud"/>
                </div>

                <!-- Modal Body -->
                <div class="welcome__modal__body w-100 d-flex align-items-stretch flex-wrap p-0">
                    <PostMenu v-if="openModal" :title="postsMenuTitle" :relative="relativeMenuPosition" width="30%"/>

                    <vue-scroll :ops="vueScrollOptions" ref="scrollable" :style="{ height: '100%', width: '70%' }">
                        <!-- {{ activePost }} -->
                        <transition name="el-fade-in-linear">
                            <section class="container-fluid py-5 px-5" v-if="activePost && !hidePost">
                                <el-row :gutter="0" class="border-bottom pb-3">
                                    <el-col :span="12">
                                        <h3 :style="{ fontSize: '1.25rem !important' }">
                                            {{ activePost.notification.subject }}</h3>
                                    </el-col>
                                    <el-col :span="12" class="text-right">
										<span class="font-weight-bolder" :style="{ fontSize: '0.85rem' }">
											{{ activePost.notification.date | moment("dddd, MMMM Do YYYY, h:mm a") }}
										</span>
                                    </el-col>
                                </el-row>

                                <el-row :gutter="0" class="mt-3">
                                    <el-col :span="24">
                                        <section v-html="activePost.notification.content"></section>
                                    </el-col>
                                </el-row>
                            </section>
                        </transition>
                    </vue-scroll>
                </div>

                <!-- Modal Footer -->
                <div class="welcome__modal__footer w-100 d-flex align-items-center justify-content-between">
                    <!-- LHS -->
                    <div>
                        <!-- <el-button
              v-if="isUserAdmin"
              @click="toggleAdmin"
              :type="openAdminMenu ? 'warning' : 'danger'"
              :icon-OFF="openAdminMenu ? 'el-icon-close' : 'el-icon-setting'"
              plain
            >
              {{ openAdminMenu ? "Exit Admin" : "Admin" }}
              <i :class="['ml-1 el-icon-right', openAdminMenu ? 'el-icon-close' : 'el-icon-setting']"></i>
            </el-button> -->
                        <!-- <el-checkbox v-model="dontShowAgain" label="Don’t show again." border size="mini"></el-checkbox> -->
                    </div>

                    <!-- RHS -->
                    <div>
                        <el-button @click="toggleModal(false)" type="success" :disabled="false" plain>Continue
                        </el-button>
                        <!-- {{ height }} -->
                    </div>
                </div>
            </section>
        </section>
    </section>
</template>

<script>
import {mapGetters, mapState} from "vuex"
import {mapStore} from "@shared/lib/Helpers"

import store from "./store"
import PostMenu from "./PostMenu"

export default {
    name: "SupportNotifications",
    store,
    components: {
        PostMenu,
    },
    props: ["isReferrer"],
    data() {
        return {
            notificationChannel: null,
            openModal: false,
            dontShowAgain: false,
            postsMenuTitle: "Previous Posts",
        }
    },
    computed: {
        ...mapState(["vueScrollOptions", "height", "isLoading", "relativeMenuPosition", "referrer"]),
        ...mapGetters(["activePost", "unreadCount", "notifications"]),
        ...mapStore(["openPostsMenu", "hidePost"]),

        showButton() {
            return this.notifications.length > 0
        },
    },
    watch: {},
    mounted() {
        this.fetchNotifications()

        window.addEventListener("resize", () => this.setHeights("scrollable"))

        this.notificationChannel = Echo.private(`tenant_create_notification`).listen(".tenant-notification-created", (event) => {
            this.fetchNotifications()
        })

        this.openModal = Ambition.getGlobal('tenant.whatsNewPopupEnabled')
    },
    destroyed() {
        this.notificationChannel.leave
    },
    beforeDestroy() {
        window.removeEventListener("resize", () => this.setHeights("scrollable"))
    },
    updated() {
        this.setHeights("scrollable")
    },
    activated() {
    },
    methods: {
        toggleModal(open) {
            this.openModal = open
        },

        fetchNotifications() {
            this.$store.dispatch("fetchNotifications")
        },

        setHeights(refName) {
            if (!this.$refs[refName]) return false
            const refHeight = $(this.$refs[refName].$el).innerHeight()
            this.$store.dispatch("setHeight", {name: refName, height: refHeight})
        },

    },
}
</script>

<style lang="scss" scoped>
@import "@assets/sass/backend/_core-variables.scss";

$color-bg: #111;
$color-fg: #222;
$color-modal: #fff;
$size: 90%;
$max-width: 1400px;
$padding: 30px;

$height-header: 10%;
$height-footer: $height-header;
$height-body: 100% - $height-header - $height-footer;

.welcome--absolute-center {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.welcome {
    @extend .welcome--absolute-center;
    // z-index: 999999;
    z-index: 1050;
}

.welcome__modal {
    @extend .welcome--absolute-center;
    // overflow-y: scroll;
    overflow: hidden;
    max-width: $max-width;
    width: $size;
    height: $size;
    // max-width: 90%;
    background-color: rgba($color-modal, 1);

    border-radius: 4px;
    border: 1px solid #ebeef5;
    // font-size: 12px;
    box-shadow: 0 2px 12px 0 rgba(#000, 0.25);

    .welcome__modal__header {
        // margin-bottom: 18px;
        border-bottom: 1px solid #dee2e6;
        padding: 0 $padding;
        height: $height-header;

        .welcome__modal__header__logo {
            height: 38px;
            // max-height: 50%;
        }
    }

    .welcome__modal__body {
        $padding-body: 5px;
        height: $height-body;
        // padding: $padding;
        // overflow-y: scroll;

        overflow: hidden;
        padding: $padding-body;
    }

    .welcome__modal__footer {
        height: $height-footer;
        border-top: 1px solid #dee2e6;
        padding: $padding;
        // position: absolute;
        // bottom: 0;
        width: 100%;
    }
}

.welcome__button {
    $height: 35px;
    $offset: 25px;
    $border-width: 1px;

    $bg-color: $color-ambition;
    // $bg-color-danger: #f56c6c;
    $bg-color-danger: #dc3545;

    z-index: 999;
    position: fixed;
    right: -$offset;
    bottom: 50px;
    margin-top: ($height * 2) + $offset;
    transform: translateY(-50%) rotate(90deg);
    transform-origin: top right;
    min-width: 150px;
    // padding: 0px 20px;
    height: $height + $offset;
    line-height: $height;
    background-color: rgba(darken($bg-color, 10%), 1);
    text-align: center;
    color: #fff;
    // border: solid #dee2e6;
    // border-width: 0 $border-width $border-width;
    box-shadow: 2px 2px 6px 0px rgba(#222, 0.35);
    transition: all 0.15s ease-in-out;

    &:hover {
        cursor: pointer;
        right: 0;
    }

    &.has-unread {
        background-color: rgba(darken($bg-color-danger, 10%), 1);

        .welcome__button__text {
            background-color: rgba(darken($bg-color-danger, 0%), 1);
        }
    }

    .welcome__button__text {
        display: inline-block;
        background-color: rgba(darken($bg-color, 0%), 1);
        width: 100%;
        height: $height;
        position: absolute;
        left: 0;
        bottom: 0;
        line-height: $height;
    }

    .welcome__button__badge {
        position: absolute;
        bottom: -10px;
        right: -15px;
        transform: rotate(-90deg);
    }
}

.welcome__background {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    background-color: rgba($color-bg, 0.75);
}
</style>

<style lang="scss">
.welcome {
    .welcome__modal__reading-time {
        .el-progress-bar {
            .el-progress-bar__inner,
            .el-progress-bar__outer {
                border-radius: 0;
            }

            .el-progress-bar__innerText {
                font-size: 10px;
            }
        }
    }

    .welcome__modal__body__card {
        .el-card__header,
        .el-card__body {
            padding-left: 0;
            padding-right: 0;
        }
    }

    .welcome__modal__body__card__carousel {
        .el-carousel__item {
            text-align: center;

            h3 {
                color: #475669;
                font-size: 14px;
                opacity: 0.75;
                line-height: 150px;
                margin: 0;
            }
        }

        .el-carousel__item:nth-child(2n) {
            background-color: #99a9bf;
        }

        .el-carousel__item:nth-child(2n + 1) {
            background-color: #d3dce6;
        }
    }

    // [contenteditable="true"] {
    //   border: 1px solid #dee2e6;
    //   padding: 15px;
    // }
}
</style>
